import stgLogo from '@gameday/common/assets/images/stg_pos_black_sm.png'
import gameday from '@gameday/common/assets/images/stg_pos_color_sm.png'
import RegistrationFooter from '@gameday/common/components/form/Common/RegistrationFooter'
import LoginPage from '@gameday/react-components/components/LoginPage'
import { rem } from '@gameday/react-components/utils/theme'
import withWidth from '@material-ui/core/withWidth'
import { isNil } from 'lodash'
import { useEffect } from 'react'
import styled from 'styled-components'

import routes from '../../../../constants/routes/routes'
import { buildPath } from '../../../../utils/common'

const StyledFooter = styled.div`
  width: 100%;
  & > footer {
    display: flex;
    flex-direction: column;
    margin-top: 30px;
  }
`

const StyledGamedayLogo = styled.img`
  width: auto;
  height: ${rem(35)};
  margin-bottom: ${rem(15)};
`

const Login = ({
  signin,
  history,
  loginErrorType,
  isSubmitPending,
  loginMsg,
  eventLogo,
  landingPageLogo,
  orgLogo,
  formType,
  guestRegistration,
  setLoginError,
  width,
  resendVerificationEmail,
  successMsg,
  recaptcha,
  resetForm,
  paymentProviders,
  getSystemAlert,
  systemAlert = {},
  organisation,
  socials,
  eventDetails,
  formSettings,
}) => {
  useEffect(() => {
    getSystemAlert()
    setLoginError(undefined)
    resetForm()
  }, [])

  const { alertTitle, alertType, alertMessage, isActive, applyTo = '' } = systemAlert || {}
  const { bgGradientPrimaryColor, bgGradientSecondaryColor, landingPageImage } = formSettings || {}

  const noGuestTitle = 'Login or Sign up'

  const guestTitle = 'Login or Sign up / Continue as Guest'

  const showAlert = isActive && applyTo !== 'Admin Portal'
  const alert = showAlert
    ? {
        alertVariant: !isNil(alertType) && alertType !== '' ? alertType.toLowerCase() : '',
        alertTitle: !isNil(alertTitle) && alertTitle !== '' ? alertTitle : '',
        alertMessage: !isNil(alertMessage) && alertMessage !== '' ? alertMessage : '',
      }
    : {}

  return (
    <>
      <LoginPage
        redirectForgotPasswordPath={buildPath(formType, routes.forgotPassword.path, history)}
        redirectSignUpPath={buildPath(formType, `${routes.signup.path}/${history.location.search}`, history)}
        redirectSignUpGuestPath={buildPath(formType, `${routes.signupGuest.path}/${history.location.search}`, history)}
        history={history}
        logo={formType === 'event' ? eventLogo : orgLogo || landingPageLogo || gameday}
        title={guestRegistration ? guestTitle : noGuestTitle}
        handleSubmit={(...args) => {
          recaptcha()
            .then(() => {
              signin(...args)
            })
            .catch(() => {
              setLoginError({
                type: 'ReCAPTCHA',
                message: 'Abnormal action detected',
              })
            })
        }}
        showTermsAndConditions
        showSignUp
        loadingLogin={isSubmitPending}
        emailErrorMessage={loginErrorType === 'account' ? 'Account not found with that email' : ''}
        passwordErrorMessage={loginErrorType === 'password' ? 'Incorrect password entered' : ''}
        formError={loginMsg}
        formSuccess={successMsg}
        onChange={() =>
          setLoginError({
            type: null,
            message: '',
          })
        }
        application={width !== 'xs' ? 'desktop' : 'mobile'}
        handleResendVerificationEmail={resendVerificationEmail}
        termsLogo={stgLogo}
        showGuestLogin={guestRegistration}
        paymentProviders={<StyledGamedayLogo src={gameday} />}
        showAlert={showAlert}
        primaryColor={bgGradientPrimaryColor}
        secondaryColor={bgGradientSecondaryColor}
        {...(landingPageImage && { backgroundImage: landingPageImage })}
        {...alert}
      />
      <StyledFooter>
        <RegistrationFooter
          isEvent={formType === 'event'}
          logo={formType === 'event' ? eventLogo : orgLogo}
          organisation={{
            ...organisation,
            ...socials,
            ...(formType === 'event' && { website: eventDetails.website }),
          }}
          paymentGateway={paymentProviders}
          event={{
            ...(formType === 'event' && {
              address: eventDetails.address,
              venueName: eventDetails.venueName,
              name: eventDetails.eventName,
            }),
          }}
          subdomain={formSettings.subdomain}
        />
      </StyledFooter>
    </>
  )
}

export default withWidth()(Login)
